module.exports = __webpack_public_path__ + "res/4-img_reward_m.02b83f227f48c87a83b7545c0bfefb0c.png";